export const blockIconsTransportationElectricMopedNew = (
	<span className='material-symbols-outlined'>electric_moped</span>
);
